module.exports = __webpack_public_path__ + "img/mode-test--icon.80bc64c7.svg";